export default [
    {
        "year": 1985,
        "question": "选出注音没有错误的一组（ ）",
        "A": "干涸（hé）、闲暇（xiá）、桎梏（gào）",
        "B": "炽（zhì）、烈檄（xí）、文鞭答（chi）",
        "C": "愤港（mèn）、缔（dì）、造鞭挞（tà）",
        "D": "真谛（di）、酗（xiōng）酒、澹（dàn）然",
        "answer": "C"
    },
    {
        "year": 1986,
        "question": "下列标题中加点的字各有四种解释，选出正确的一种：《“察”今》",
        "A": "察看",
        "B": "明察",
        "C": "视察",
        "D": "观察",
        "answer": "B"
    },
    {
        "year": 1987,
        "question": "下列四个词语中加红字都有几种不同的解释，选出正确的一种：不“遗”余力",
        "A": "漏掉",
        "B": "剩下",
        "C": "丢失",
        "D": "赠送",
        "answer": "B"
    },
    {
        "year": 1988,
        "question": "选出红字意义相同的一组（ ）",
        "A": "长歌当哭、当机立断",
        "B": "残羹冷炙、脍炙人口",
        "C": "毫厘不爽、爽心乐悦",
        "D": "春和景明、承天景命",
        "answer": "B"
    },
    {
        "year": 1989,
        "question": "“然而可得并者，政恶故也”这句话的正确译文是（）",
        "A": "然而能够取得那些城高人众二者并具的地方，是因为那些地方政治不好。",
        "B": "然而却能够取得那些城高人众二者并具的地方，说明魏国政治不好",
        "C": "然而那些地方能够被兼并，是因为那些地方政治不好。",
        "D": "然而却能够兼并那些地方，说明魏国的政治不好。",
        "answer": "C"
    },
    {
        "year": 1990,
        "question": "“上车弗谢而去”中的谢是什么意思？",
        "A": "道歉",
        "B": "告诉",
        "C": "感谢",
        "D": "告辞",
        "answer": "D"
    },
    {
        "year": 1991,
        "question": "下列汉字笔画数不全相同的一组是（ ）",
        "A": "瓦长片毋",
        "B": "瓜鸟凹辽",
        "C": "廷岌祁丞",
        "D": "延孜舛尧",
        "answer": "B"
    },
    {
        "year": 1992,
        "question": "选出字形无误的一句（ ）",
        "A": "按照上级布署，他们认真组织了一系列观摩课，师生们反应热烈",
        "B": "别看他俩在一起有说有笑的，其实是貌和神离",
        "C": "我们都迫不急待地想知道，究竟是谁能赢得最后的胜利",
        "D": "这哥儿俩，一个标新立异，一个循规蹈矩，差别太大了！",
        "answer": "D"
    },
    {
        "year": 1993,
        "question": "下列词语中红字的字读音全都正确的一组是（ ）",
        "A": "引擎（qing）、联袂（mèi）、泊位（pò）、恬不知耻（tián）",
        "B": "羞赧（něn）、果脯（pǔ）、澎湃（pài）、咬文嚼字（jué）",
        "C": "湍急（tuān）、阐（shàn）明、天堑（qiàn）、一曝十寒（pù）",
        "D": "破绽（zhàn）、怯懦（nuò）、颤动（chàn）、一叶扁舟（pian）",
        "answer": "D"
    },
    {
        "year": 1994,
        "question": "下列成语中红字的字的读音、字形全都正确的一组是（ ）",
        "A": "殚精竭虑（dan）、相形见绌（chù）、怙恶不悛（quān）、有恃无恐（shshì）",
        "B": "潸然泪下（shān）、仗义直言（zhi）、断壁颓垣（yuán）、义愤填膺（yīng）",
        "C": "杳无音信（yěo）、纵横捭阖（běi）、天崩地坼（chè）、称心如意（chēng）",
        "D": "偃旗息鼓（yěn）、铤而走险（tǐng）、如火如荼（tú）、循规蹈矩（jù）",
        "answer": "A"
    },
    {
        "year": 1994,
        "question": "下列词语中红字的字，字形、字音全都正确的一组是（ ）",
        "A": "哺（bǔ）育、 拓（t uò）片、嗔（chēn）怪、伺（cì）候",
        "B": "气馁（něi）、禅（shàn）让、重迭（d ié）、轮廓（k uò）",
        "C": "殷（yān）红、狙（jū）击、皈（g ui依）、屏（bǐn g）除",
        "D": "畸（qí）形、歼（jiān）灭、抨（pēng）击、对峙（z hi）",
        "answer": "C"
    },
    {
        "year": 1996,
        "question": "下列词语中的红字，读音全都正确的一组是（ ）",
        "A": "绮（qǐ）丽、箴（j iēn）言、乳臭（xiù）未干",
        "B": "擂（lèi）台、皎（jiǎo）洁、卷帙（zhi）浩繁",
        "C": "戕（qiāng）害、璞（pǔ）玉、塞（sài）翁失马舞",
        "D": "踪迹（ji）、姊（jiě）妹、载（zài）歌载",
        "answer": "B"
    },
    {
        "year": 1997,
        "question": "下列四组词语中都有错别字，其中只有一个错别字的一组是（ ）",
        "A": "浑浑噩噩、针贬时弊、狗苟蝇营、贪脏枉法",
        "B": "脱颖而出、繁文缛节、回肠荡气、不胫而走",
        "C": "风声鹤唳、纷至踏来、积毁消骨、穿凿附会",
        "D": "人才汇萃、草菅人命、风靡一时、步履维艰",
        "answer": "D"
    },
    {
        "year": 1998,
        "question": "下列各组词语中有错别字的一组是（ ）",
        "A": "具备、万事俱备、风声、谈笑风生",
        "B": "求实、实事求是、世故、人情事故",
        "C": "陈规、墨守成规、精心、漫不经心",
        "D": "直接、直截了当、剧增、 与日俱增",
        "answer": "B"
    },
    {
        "year": 1999,
        "question": "下列各组词语中，只有一个错别字的一组是（ ）",
        "A": "翔实、词不达意、冷寞、一筹莫展",
        "B": "痉李、不经之谈、偏辟、励精图治",
        "C": "风靡、葉根、祸种、攀缘、始作俑者",
        "D": "倾轧、气冲宵汉、弘扬、扑溯迷离",
        "answer": "C"
    },
    {
        "year": 2000,
        "question": "下列各组词语中，没有错别字的一组是（ ）",
        "A": "拖沓、娇生惯养、伶俐、倜傥不羁",
        "B": "造次、索然寡味、迁徙、惨绝人圓",
        "C": "描摹、幅员辽阔、惶恐、法网恢恢",
        "D": "窥测、慷慨激昂、提要、钩玄",
        "answer": "C"
    },
    {
        "year": 2001,
        "question": "下列各组词语中，没有错别字的一组是（ ）",
        "A": "戳穿、力挽狂澜、暧昧、食不果腹",
        "B": "震撼、融汇贯通、喧嚣、响彻云霄",
        "C": "深奥、死不瞑目、气慨、雍容华贵",
        "D": "凋蔽、哗众取宠、辍学、愤世嫉俗",
        "answer": "A"
    },
    {
        "year": 2002,
        "question": "下列各组词语中，有错别字的一组是（  ）",
        "A": "留恋、流连忘返、厉害、利害得失",
        "B": "质疑、不容置疑、符合、随声附合",
        "C": "变换、变幻莫测、旁证、旁征博引",
        "D": "株连、珠联璧合、大意、微言大义",
        "answer": "B"
    },
    {
        "year": 2003,
        "question": "下列词语中没有错别字的一组是（）",
        "A": "部署、备受青睐、恰如其分、可望而不可即",
        "B": "报道、伶牙利齿、群贤毕至、一年之计在于春",
        "C": "揣度、共商国是、唾手可得、冒天下之大不违",
        "D": "通谍、猝不及防、大相径庭、盛名之下其实难副",
        "answer": "A"
    },
    {
        "year": 2004,
        "question": "下列词语没有错别字的一组（ ）",
        "A": "班配、藏污纳垢、草菅人命、看菜吃饭，量体裁衣",
        "B": "凌厉、怙恶不悛、不落巢臼、己所不欲，勿施于人",
        "C": "懵懂、挺而走险、流言蜚语、如临深渊，如履薄冰",
        "D": "怄气、徒有虚名、鬼斧神工、失之毫厘，谬以千里",
        "answer": "D"
    },
    {
        "year": 2005,
        "question": "下列词语中没有错别字的一组是（ ）",
        "A": "切磋、洽谈会、悬梁刺股、覆水难收",
        "B": "气概、水笼头、风雨如晦、落荒而逃",
        "C": "招募、度假村、有恃无恐、试目以待",
        "D": "怅惘、挖墙脚、功亏一篑、矫枉过正",
        "answer": "D"
    },
    {
        "year": 2006,
        "question": "下列各组词语中，有两个错别字的一组是（ ）",
        "A": "啜泣、层峦叠嶂、嗑碰、义愤填膺",
        "B": "辑拿、额手称庆、坍塌、班师回朝",
        "C": "秸秆、大有稗益、赘述、披肝沥胆",
        "D": "摩娑、厝火积薪、巨擘、见风驶舵",
        "answer": "D"
    },
    {
        "year": 2007,
        "question": "下列各组词语中，没有错别字的一组是（ ）",
        "A": "淤积、绿茵场、娇健、独占鳌头",
        "B": "联结、抠字眼、引申、拾人牙惠",
        "C": "融资、殊不知、传诵、委曲求全",
        "D": "繁衍、冠名权、坚韧、磬竹难书",
        "answer": "C"
    },
    {
        "year": 2008,
        "question": "对下列句子中词的解释不正确的是（ ）",
        "A": "部使者檄刚抚定　　檄：文告",
        "B": "刚遣长子迟喻贼　　喻：开导",
        "C": "愿稽旧制，选精锐为亲兵　稽：查考",
        "D": "以杜金人窥伺之意　杜：制止",
        "answer": "A"
    },
    {
        "year": 2009,
        "question": "下列词语中读音完全正确的一组是（ ）",
        "A": "菁华（qīng）、宁可（nìng）、冠心病（guān）、翘首回望（qiáo）",
        "B": "吐蕃（fān）、庇护（bì）、歼击机（jiān）、呱呱坠地（gū）",
        "C": "请帖（tiě）、梵文（fán）、发横财（hèng）、按捺不住（nà）",
        "D": "链接（liàn）、创口（chuāng）、倒春寒（dào）、拈花惹草（niān）",
        "answer": "D"
    },
    {
        "year": 2010,
        "question": "下列词语中读音全都正确的一组是（ ）",
        "A": "行伍（háng）、名宿（sù）、恶贯满盈（yíng）、厉兵秣马（mù）",
        "B": "倾轧（zhá）、不啻（chì）、荆钗布裙（chāi）",
        "C": "巨擘（bò）、河蚌（bàng）、得不偿失（cháng）、莘莘学子（shēn）",
        "D": "解剖（pāo）、羁绊（jī）、火中取栗（lì）、 感慨系之（xì）",
        "answer": "C"
    },
    {
        "year": 2011,
        "question": "下列词语中读音全都正确的一组是（ ）",
        "A": "逾越（yú）、鸟瞰（kàn）、一丘之貉（lùo）、栩栩如生（xǚ）",
        "B": "溃败（kuì）、凹陷（wā）、贻笑大方（yí）、兢兢业业（jīng）",
        "C": "咀嚼（zǔ）、桧柏（guì）、罄竹难书（qìng）、饕餮大餐（tiè）",
        "D": "觊觎（jì）、攻讦（jié）、 光阴荏苒（rǎn）、心怀叵测（pǒ）",
        "answer": "D"
    },
    {
        "year": 2012,
        "question": " 下列词语中，没有特别字的一组是（ ）",
        "A": "镶嵌 、精萃 、休闲装 、轻描淡写 ",
        "B": "瑕疵 、鄙薄、 邀请赛、 赔礼道歉",
        "C": "怃然 、琵琶 、和稀泥、 玲珑剔透",
        "D": "推辞 、观摩 、元霄节 、伶牙俐齿",
        "answer": "C"
    },
    {
        "year": 2013,
        "question": "下列词语中读音全都正确的一组是（ ）",
        "A": "女红（gōng）、安土重迁移（zhòng）、商埠(fǔ)、花团锦簇（cù）",
        "B": "莅临（lì）、大放厥词（jué）、挟制（xié）、蔫头呆脑（yān）",
        "C": "懦弱（nuò）、年高德劭（shāo）、两栖（qī）、沁人心脾（qīn）",
        "D": "遽然（jù）、精神抖擞（sǒu）、塌陷（tā）、一柱擎天（qíng）",
        "answer": "C"
    },
    {
        "year": 2014,
        "question": "下列词语中读音全都正确的一组是（ ）",
        "A": "龃龉（yǔ) 、系鞋带(xi)、舐犊情深（shi)、曲意逢迎（qū)",
        "B": "倜傥(tǎng)、纤维素（xiān)、羽扇纶巾(guān )、针砭时弊(biān",
        "C": "感喟(kuì)、揭疮疤（chuāng)、按捺不住（nài)、大相径庭（jing)",
        "D": "霰弹 (xiàn )、涮羊肉（shuàn)、以儆效尤（jǐng) 、纵横捭阖必（bì)",
        "answer": "B"
    },
    {
        "year": 2015,
        "question": "下列词语中，注音全都正确的一项是（    ）",
        "A": "纠葛（gé）、瓜蔓（màn）、牛皮癣（xuǎn）、为（wèi）虎作伥",
        "B": "惬（qiè）意、觊（jì）觎、蒙（měng）蒙亮   扺（zhǐ）掌而谈 ",
        "C": "谄（chǎn）媚、压轴（zhóu）、一溜（liù）烟、间不容发（fà）",
        "D": "豆豉（chǐ）、箴（zhēn）言、轧（zhá）马路、门揖（yī）盗",
        "answer": "B"
    },
    {
        "year": 2016,
        "question": "下列词语中，注音全部都正确的一项是（ ）",
        "A": "煲汤（bāo）恫吓（dòng）脐带血（jì）整齐划一（huà）",
        "B": "古刹（chà）衣钵（bō）挑大梁（tiǎo）言为心声（wèi）",
        "C": "掣肘（chè）卤味（lǔ）处女座（chǔ）寅吃卯粮（yín）",
        "D": "笃定（dǔ）痤疮（cuó）病恹恹（yāng）血气方刚（xuè）",
        "answer": "C"
    },
    {
        "year": 2017,
        "question": "下列词的解释，不正确的一项是（ ）",
        "A": "助书贾鬻．书于市      鬻：卖 ",
        "B": "先生往谒．     谒：拜见 ",
        "C": "称之不置．      置：置办",
        "D": "尚欲扬榷而陈．之       陈：陈述 ",
        "answer": "C"
    },
    {
        "year": 2018,
        "question": "下列句中词的解释，不正确的一项是（ ）",
        "A": "时不胜月       时：季节",
        "B": "仅存之国危而后戚之       戚：为……悲伤",
        "C": "智士贤者相与积心愁虑以求之      相与：一同、都",
        "D": "取其金，则无损于行      行：行为",
        "answer": "D"
    },
    {
        "year": 2019,
        "question": "下列词语的解说，不正确的一项是（ ）",
        "A": "较之别处更能接纳后进    后进：资历较浅的后辈",
        "B": "大致都在形胜之地       形胜：外形优美",
        "C": "燕赵毕竟是慷慨悲歌之地        慷慨悲歌：激昂悲壮，有英雄气概",
        "D": "北方生活的伟大幽闲        幽闲：清静闲适",
        "answer": "B"
    },
    {
        "year": 2020,
        "question": "下列对句中“以”字的解释，不正确的一项是（ ）",
        "A": "欲以伐四卿    以：凭借",
        "B": "以汾水可以灌魏之安邑    以：用",
        "C": "主何以臣之言告二子也    以：把、将",
        "D": "子何以知之    以：依据",
        "answer": "B"
    }
]